import { useState, useEffect } from "react";
import useScript from "./use-script";
import { isBrowser, injectStyle } from "../libs/utils/dom";

type useRecaptchaParams = {
    sitekey: string;
    hideDefaultBadge: boolean;
};

export const useRecaptcha = (parameters: useRecaptchaParams) => {
    const { hideDefaultBadge, sitekey } = parameters;
    const [recaptcha, setRecaptcha] = useState<typeof window.grecaptcha>();
    const recaptchaUrl = `https://www.google.com/recaptcha/api.js?render=${sitekey}`;

    useEffect(() => {
        if (isBrowser && hideDefaultBadge) {
            injectStyle(".grecaptcha-badge { visibility: hidden; }");
        }
    }, [hideDefaultBadge]);

    useScript({
        src: recaptchaUrl,
        async: true,
        checkForExisting: true,
        onload: () =>
            window.grecaptcha.ready(() => {
                setRecaptcha(window.grecaptcha);
            }),
    });

    useEffect(() => {
        if (window.grecaptcha) {
            window.grecaptcha.ready(() => {
                setRecaptcha(window.grecaptcha);
            });
        }
    }, []);

    return (action: string) => {
        return new Promise((resolve) => {
            if (recaptcha) {
                resolve(recaptcha.execute(sitekey, { action }));
            }
        });
    };
};
